import { render, staticRenderFns } from "./StudentGradeFullNameCell.vue?vue&type=template&id=482797f5&"
import script from "./StudentGradeFullNameCell.vue?vue&type=script&lang=js&"
export * from "./StudentGradeFullNameCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports